import { takeEvery, put, select } from 'redux-saga/effects';
import pick from 'lodash/pick';
import restaurantReportsActions from '../actionTypes/restaurantReportsActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_RESTAURANT_REPORTS } from '../routes';
import dateTimeHelpers from '../utils/dateTimeHelpers';

const getRestaurantId = (state) => state.loginReducer.currentUser.resourceable_id;

const getFilters = (state) => pick(state.restaurantReportsReducer, ['from', 'to']);

function* getRestaurantReports({ payload }) {
  const id = yield select(getRestaurantId);
  const filters = { ...(yield select(getFilters)), ...payload };

  yield put({
    type: API_CALL,
    payload: {
      url: GET_RESTAURANT_REPORTS.replace(':id', id),
      method: 'POST',
      data: {
        from: dateTimeHelpers.formatDate(filters.from),
        to: dateTimeHelpers.formatDate(filters.to),
      },
    },
    successAction: restaurantReportsActions.getRestaurantReportsSuccess,
    failureAction: restaurantReportsActions.getRestaurantReportsFailed,
  });
}

export default function* watchRestaurantReports() {
  yield takeEvery(restaurantReportsActions.getRestaurantReports, getRestaurantReports);
}
